import { Button, Popconfirm, Select, Space, Table } from "antd";
import type { ColumnsType } from "antd/lib/table";
import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { orderArchers, sumPoints, sortArchersByScore } from "../../_helpers/utils";
import FirestoreService from "../../_helpers/firestoreService";
import "./table.scss";
import { ArcheryProp } from "@/_helpers/type";
const { Option } = Select;

interface DataType {
  key?: string;
  name?: string;
  date?: string;
  hanaPoints: number[];
  hasPoints: number[];
  totalScore?: number;
}

function Archers({ competitors, loading, ranks, teams, removeArcher, competitionId }: any) {
  const userData = useSelector((state: any) => state.authentication.userData);

  const [searchKey, setSearchKey] = useState("displayName");
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [firestoreScores, setFirestoreScores] = useState<Map<number, { hanaPoints: number[], hasPoints: number[], totalScore: number }>>(new Map());

  // Subscribe to aggregated Firestore scores
  useEffect(() => {
    if (!competitionId) return;

    const unsubscribe = FirestoreService.subscribeToAggregatedScores(
      parseInt(competitionId),
      (scores) => {
        setFirestoreScores(scores);
      }
    );

    return () => unsubscribe();
  }, [competitionId]);

  // Merge competitors with Firestore scores
  const competitorsWithScores = useMemo(() => {
    return competitors.map((comp: any) => {
      const firestoreData = firestoreScores.get(comp.id);
      return {
        ...comp,
        hanaPoints: firestoreData?.hanaPoints || comp.hanaPoints || [],
        hasPoints: firestoreData?.hasPoints || comp.hasPoints || [],
        totalScore: firestoreData?.totalScore || 0,
      };
    });
  }, [competitors, firestoreScores]);

  // Sort by score if Firestore data exists, otherwise use rank-based ordering
  const orderedCompetitors: ArcheryProp[] = useMemo(() => {
    if (firestoreScores.size > 0) {
      return sortArchersByScore(competitorsWithScores);
    }
    return orderArchers(competitorsWithScores);
  }, [competitorsWithScores, firestoreScores]);

  const ranksFilter: any[] = [];

  ranks.map((rank: any) => {
    ranksFilter.push({
      text: rank.name,
      value: rank.order,
    });
  });

  const columns: ColumnsType<DataType> = [
    {
      width: 80,
      title: "№",
      dataIndex: "id",
      key: "id",
      fixed: 'left',
      render: (text, row, index) => <>{index + 1}</>,
    },
    {
      width: 100,
      title: "Оноо",
      dataIndex: "totalScore",
      key: "totalScore",
      render: (value, record) => {
        // Use totalScore from Firestore if available, otherwise calculate from hanaPoints/hasPoints
        const score = record?.totalScore !== undefined
          ? record.totalScore
          : (sumPoints(record?.hanaPoints || []) + sumPoints(record?.hasPoints || []));
        return score + " оноо";
      },
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const scoreA = a?.totalScore !== undefined
          ? a.totalScore
          : (sumPoints(a?.hanaPoints || []) + sumPoints(a?.hasPoints || []));
        const scoreB = b?.totalScore !== undefined
          ? b.totalScore
          : (sumPoints(b?.hanaPoints || []) + sumPoints(b?.hasPoints || []));
        return scoreA - scoreB;
      },
    },
    {
      width: 120,
      title: "Овог",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      width: 120,
      title: "Нэр",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      width: 200,
      title: "Цол",
      dataIndex: "rankId",
      key: "rankId",
      render: (value, record: any) => {
        // if (record.rank.order <= 9) {
        //   return record?.rank?.name;
        // } else if (record.rank.order > record.rank2.order) {
        //   if (record.rank.order <= 20 && record.rank.order >= 12) {
        //     return record?.rank2?.name + ", " + record?.rank?.name;
        //   } else return record?.rank2?.name;
        // } else 
          return record?.rank?.name;
      },
      filters: ranksFilter,
      onFilter: (value: any, record: any) => record.rank.order === value,
      sortDirections: ["descend"],
    },
    {
      width: 150,
      title: "Баг",
      dataIndex: "teamId",
      key: "teamId",
      render: (value, record) => {
        const currentTeam = teams.find(
          (item: { id: any }) => item.id === value
        );

        return currentTeam ? currentTeam.name : <span>-</span>;
      },
    },
    // {
    //   width: 100,
    //   title: "Эхэн өрөг эхэн",
    //   dataIndex: "ehen_points",
    //   key: "ehen_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(0, 4))
    // },
    // {
    //   width: 100,
    //   title: "Эхэн өрөг адаг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(4, 8))
    // },
    // {
    //   width: 100,
    //   title: "Дунд өрөг эхэн",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(8, 12))
    // },
    // {
    //   width: 100,
    //   title: "Дунд өрөг адаг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(12, 16))
    // },
    // {
    //   width: 100,
    //   title: "Адаг өрөг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(16, 20))
    // },
    // {
    //   width: 100,
    //   title: "Хана нийт",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hanaPoints.slice(0, 20))
    // },
    // // {
    // //   width: 100,
    // //   title: "Эхэн өрөг эхэн",
    // //   dataIndex: "ehen_points",
    // //   key: "ehen_points",
    // //   render: (value, record) => record?.hasPoints
    // // },
    // {
    //   width: 100,
    //   title: "Эхэн өрөг эхэн",
    //   dataIndex: "ehen_points",
    //   key: "ehen_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(0, 4))
    // },
    // {
    //   width: 100,
    //   title: "Эхэн өрөг адаг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(4, 8))
    // },
    // {
    //   width: 100,
    //   title: "Дунд өрөг эхэн",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(8, 12))
    // },
    // {
    //   width: 100,
    //   title: "Дунд өрөг адаг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(12, 16))
    // },
    // {
    //   width: 100,
    //   title: "Адаг өрөг",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(16, 20))
    // },
    // {
    //   width: 100,
    //   title: "Хасаа нийт",
    //   dataIndex: "ehen_dund_points",
    //   key: "ehen_dund_points",
    //   render: (value, record) => sumPoints(record?.hasPoints.slice(0, 20))
    // },
    {
      title: "Хүйс",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      filters: [
        {
          text: "Эрэгтэй",
          value: "male",
        },
        {
          text: "Эмэгтэй",
          value: "female",
        },
      ],
      onFilter: (value: any, record: any) => record.gender === value,
      sortDirections: ["descend"],
      render: (value, record) => (value === "male" ? "Эрэгтэй" : "Эмэгтэй"),
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 100,
      fixed: 'right',
      render: (_, record: any) => (
        <>
          {(userData.role === "admin" || userData.role === "superadmin") && (
            <Space size="middle">
              <Popconfirm
                title="Хасахдаа итгэлтэй байна уу?"
                onConfirm={() => removeArcher(record)}
                okText="Тийм"
                cancelText="Үгүй"
              >
                <Button type="link">Хасах</Button>
              </Popconfirm>
            </Space>
          )}
        </>
      ),
    },
  ];

  const onFinish = () => {
    console.log("search");
  };

  return (
    <>
      {/* <div className="row">
        <div className="col-lg-8">
          <Form
            layout="inline"
            style={{ marginBottom: 10 }}
            initialValues={{ type: searchKey }}
          >
            <Form.Item name="type" label="Талбар">
              <Select
                value={searchKey}
                style={{ width: 300 }}
                onChange={(val) => setSearchKey(val)}
                allowClear
              >
                <Option value="displayName">Овогоор</Option>
              </Select>
            </Form.Item>
            <Form.Item name="name" label="Хайх утга">
              <Input onChange={(e) => setSearchValue(e.target.value)} />
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button type="primary" onClick={() => onFinish()}>
                Хайх
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div> */}
      <div className="table-responsive">
        <Table
          className="table-striped-rows"
          size="middle"
          columns={columns}
          dataSource={orderedCompetitors}
          loading={loading}
          rowKey={(item): any => item.key}
          pagination={{ defaultPageSize: 16 }}
          scroll={{ x: 'max-content' }}
        ></Table>
      </div>
    </>
  );
}
export default Archers;
